// @ts-nocheck
/* eslint-disable */ /* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */ import { ReactComponent as LogoProphecy } from '../../../assets/images/Logos/logo-prophecy.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoProphecyIcon = /* @__PURE__ */ withLogoClass(LogoProphecy);
